import React from "react";
import { InfoOutlined } from "@material-ui/icons";
import { Tooltip } from "@my-scoot/component-library-legacy";
import withComponentLibraryTheme from "hocs/withComponentLibraryTheme";

export const CheckboxLabel = withComponentLibraryTheme(
  ({ label = "", tooltipText = "" }) => {
    return (
      <div>
        {label}
        <Tooltip title={tooltipText} color="primary">
          <InfoOutlined className="!tw-w-4 !tw-h-4 !tw-fill-[rgba(39,37,34,0.5)] !tw-ml-1" />
        </Tooltip>
      </div>
    );
  }
);
